import ShoppingCenter from './main';
import ShoppingCenterEdit from './edit';
import SingleShop from './singleShop';
import SourcePages from './sourcePages';
import SourceForm from './sourceForm';

const routes = [
  {
    path: '/*',
    Component: ShoppingCenter,
    props: {},
  },
  {
    path: '/:id/edit',
    Component: ShoppingCenterEdit,
    props: {},
  },
  {
    path: '/:id/sources/new',
    Component: SourceForm,
    props: {
      isNew: true,
    },
  },
  {
    path: '/:id/sources/:sourceId/edit',
    Component: SourceForm,
    props: {},
  },
  {
    path: '/:id/sources/:sourceId',
    Component: SourcePages,
    props: {},
  },
  {
    path: '/:id',
    Component: SingleShop,
    props: {},
  },
  {
    path: '/new',
    Component: ShoppingCenterEdit,
    props: {
      isNew: true,
    },
  },
];

export default routes;
